import React from 'react';
import Icon from '../../../components/AppIcon';

const UserSegmentationPanel = ({ data }) => {
  if (!data || data?.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center text-muted-foreground text-sm">
        No segmentation data available
      </div>
    );
  }

  const getSegmentIcon = (segment) => {
    switch (segment) {
      case 'Power Users':
        return 'Zap';
      case 'Regular Users':
        return 'Users';
      case 'Casual Users':
        return 'User';
      case 'At-Risk Users':
        return 'AlertTriangle';
      default:
        return 'User';
    }
  };

  const getSegmentColor = (segment) => {
    switch (segment) {
      case 'Power Users':
        return 'text-success';
      case 'Regular Users':
        return 'text-primary';
      case 'Casual Users':
        return 'text-warning';
      case 'At-Risk Users':
        return 'text-error';
      default:
        return 'text-muted-foreground';
    }
  };

  return (
    <div className="space-y-4">
      {data?.map((segment, index) => (
        <div
          key={index}
          className="p-4 bg-muted/30 rounded-lg hover:bg-muted/50 transition-smooth"
        >
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-3">
              <div className={`${getSegmentColor(segment?.segment)}`}>
                <Icon name={getSegmentIcon(segment?.segment)} size={20} strokeWidth={2} />
              </div>
              <div>
                <p className="font-medium text-foreground">{segment?.segment}</p>
                <p className="text-xs text-muted-foreground">{segment?.count?.toLocaleString()} users</p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div className="p-2 bg-card rounded">
              <p className="text-xs text-muted-foreground mb-1">Conversion Rate</p>
              <p className="text-lg font-bold text-foreground">{segment?.conversionRate}%</p>
            </div>
            <div className="p-2 bg-card rounded">
              <p className="text-xs text-muted-foreground mb-1">Avg LTV</p>
              <p className="text-lg font-bold text-success">£{segment?.avgLTV}</p>
            </div>
          </div>
        </div>
      ))}

      {/* Total Summary */}
      <div className="mt-4 p-4 bg-primary/10 rounded-lg border border-primary/20">
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium text-foreground">Total Users</span>
          <span className="text-lg font-bold text-primary">
            {data?.reduce((sum, seg) => sum + seg?.count, 0)?.toLocaleString()}
          </span>
        </div>
      </div>
    </div>
  );
};

export default UserSegmentationPanel;